import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFetchedClient } from "../../redux/actions";
import { Col, Card, Spinner, Row } from "react-bootstrap";
import { Spin, Skeleton } from "antd";
import { useParams } from "react-router-dom";
import "./profile.css";
import { BsTelephoneFill, BsInbox } from "react-icons/bs";
import {
  BiSolidMessageDetail,
  BiSolidEnvelope,
  BiSolidPhone,
} from "react-icons/bi";
import doctor2 from "../../images/doctor-jpg.png";
import user from "../../images/user.jpg";
import Pills from "../../images/pills.png";
import Health from "../../images/healthcare.png";
import medical from "../../images/medical-history.png";
import appointment from "../../images/appointment.png";
import IntakeFormService from "../../services/intakeFormService";
import ImageUploadService from "../../services/imageUploadservice";
import ClientService from "../../services/clientServices";
import { setLoading } from "../../redux/actions";

const Profile = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [client, setClient] = useState("");
  const [images, setImages] = useState("");
  const [formLoading, setFormLoading] = useState(false);
  // const [clientDetails, setClientDetails] = useState();
  const [isTodaysAppointments, setIsTodaysAppointments] = useState([]);
  const intakeFormService = new IntakeFormService();
  const clientService = new ClientService();
  const imageUploadService = new ImageUploadService();
  const dispatch = useDispatch();
  const clientDetails = useSelector((state) => state.fetchedClient);

  useEffect(() => {
    const fetchForms = async () => {
      try {
        setFormLoading(true);
        let formsData;
        if (id) {
          formsData = await intakeFormService.getIntakeFormByClientId(id);
          setData(formsData.data);
          setIsLoading(false);
          setFormLoading(false);
        }
      } catch (error) {
        console.error("Error fetching forms:", error);
        setFormLoading(false);
      }
    };

    fetchForms();
  }, [id]);

  useEffect(() => {
    const fetchDoctorDetails = async () => {
      try {
        if (id) {
          const clientData = await clientService.getClients(id);
          dispatch(setFetchedClient(clientData));
          dispatch(setLoading(false));
          if (
            clientData?.assignedDoctor &&
            Array.isArray(clientData.assignedDoctor)
          ) {
            const doctorImages = await Promise.all(
              clientData.assignedDoctor.map(async (doctor) => {
                const resizedImage = await imageUploadService.getResizedImage(
                  doctor.image
                );
                return { doctorId: doctor.doctorId, image: resizedImage };
              })
            );

            setImages(doctorImages);
          }
        }
      } catch (clientError) {
        console.error("Error fetching client details:", clientError);
        dispatch(setLoading(false));
      } finally {
        setIsLoading(false);
      }
    };

    fetchDoctorDetails();
  }, [id, dispatch]);

  const formatTime = (time) => {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    return new Date(time).toLocaleDateString("en-US", options);
  };

  const handleRectangleClick = (url) => {
    window.open(url, "_blank");
  };
  const getImageByType = (type) => {
    switch (type) {
      case "GIForms":
        return Health;
      case "MHForms":
        return medical;
      case "SAForms":
        return Pills;
      case "CForms":
        return Pills;
      case "IFForms":
        return Pills;
      case "COVIDForms":
        return medical;
      default:
        return Pills;
    }
  };
  const filteredForms = data.filter(
    (form) => form.FormStatus === "Open" || form.FormStatus === "Incomplete"
  );
  const renderDoctorCards = () => {
    const assignedDoctors = clientDetails?.assignedDoctor || [];

    if (!assignedDoctors || assignedDoctors.length === 0) {
      return (
        <div className="doctor-row1">
          <div className="doctor-card">
            <Card className="doctor-details">
              <div className="card-title">Your Practitioner</div>
              <Card.Body className="doc-card-body" style={{ padding: "0px" }}>
                <div className="doctor-info">
                  <div className="no-doctor-message">
                    <p>No assigned Practitioner</p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      );
    }
    const renderCards = (doctors) => {
      return doctors.map((doctor, index) => (
        <Col key={index} xs={12} sm={6} md={4} lg={4} xl={4} className="mb-3">
          <Card className="doctor-details">
            <div className="card-title">Your Practitioner</div>
            <Card.Body className="doc-card-body" style={{ padding: "0px" }}>
              <div className="doctor-info">
                <div
                  className="doctor-name"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "60%",
                  }}
                >
                  {doctor.image ? (
                    images && images[index]?.image ? (
                      <img
                        className="doctor-img"
                        src={images[index].image.imageURL}
                        alt="doc"
                      />
                    ) : (
                      <Skeleton.Avatar
                        active
                        size={70}
                        shape="circle"
                        style={{ marginRight: "10px" }}
                      />
                    )
                  ) : (
                    <Skeleton.Image
                      className="doctor-img"
                      style={{
                        height: "70px",
                        width: "70px",
                        marginRight: "5px",
                        borderRadius: "50%",
                      }}
                    />
                  )}

                  <div
                    style={{
                      display: "flex",
                      marginLeft: "5px",
                      flexDirection: "column",
                      alignSelf: "center",
                      width: "60%",
                    }}
                  >
                    <p
                      style={{
                        marginBottom: "0px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >{`${doctor.firstName} ${doctor.lastName}`}</p>
                    <p
                      style={{
                        fontSize: "16px",
                        height: "10%",
                        color: "grey",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {doctor.specialization}
                    </p>
                  </div>
                </div>
                <div className="doctor-icons">
                  <div className="doctor-icons1">
                    <BiSolidEnvelope />
                  </div>
                  <div className="doctor-icons2">
                    <BiSolidPhone />
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      ));
    };
    if (assignedDoctors.length === 1) {
      return renderCards(assignedDoctors);
    }
    return (
      <div>
        <Row>{renderCards(assignedDoctors)}</Row>
      </div>
    );
  };
  return (
    <div className="page-wrapper">
      <div className="doctor-forms">
        <div className="welcome-text text-left">
          <h3 className="cust-name">
            Hello, {clientDetails?.firstName} !
            <br />
            <p className="text">How are you feeling today?</p>
          </h3>
          <div className="action-icons">
            <div className="action1">
              <BiSolidMessageDetail />
            </div>
            <div className="action2">
              <BsTelephoneFill />
            </div>
          </div>
        </div>
        <div className="central-cards">
          <div className="doctors">{renderDoctorCards()}</div>
          <Card className="forms-card">
            <Card
              className="inner-card"
              style={{
                backgroundColor: "rgb(241 241 244)",
                paddingBottom: "5px",
              }}
            >
              <img className="doctor2" src={doctor2} alt="Practitioner 2" />
              <Col className="sub-forms">
                {isLoading ? (
                  <>
                    {[...Array(3)].map((_, index) => (
                      <Card
                        key={index}
                        className={`form${index}`}
                        style={{ marginBottom: "10px" }}
                      >
                        <div className="form-content">
                          <div className="form-pills">
                            <Skeleton.Avatar
                              active
                              size={90}
                              shape="circle"
                              style={{ marginRight: "10px" }}
                            />
                          </div>
                          <div className="form-body-content">
                            <Card.Title
                              className="form-body-content-title"
                              style={{ padding: "0px" }}
                            >
                              <Skeleton.Input
                                style={{ width: "150px" }}
                                active
                              />
                            </Card.Title>
                            <Card.Body
                              className="form-body-content-body"
                              style={{ padding: "0px", cursor: "pointer" }}
                            >
                              <p>
                                <Skeleton.Input
                                  style={{ width: "80px" }}
                                  active
                                />
                              </p>
                              <p>
                                <Skeleton.Input
                                  style={{ width: "80px" }}
                                  active
                                />
                              </p>
                            </Card.Body>
                          </div>
                        </div>
                      </Card>
                    ))}
                  </>
                ) : filteredForms.length > 0 ? (
                  filteredForms?.map((form, box) => (
                    <Card
                      key={form.formId}
                      className={`form${form.index}`}
                      style={{
                        marginBottom: "10px",
                        marginTop: "5px",
                        boxShadow: "5px 8px 15px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      <div className="form-content">
                        <div className="form-pills">
                          <img
                            className="form-pill-icon"
                            src={getImageByType(form.type)}
                            // style={{ height: "50px", width: "50px" }}
                          />
                        </div>
                        <div className="form-body-content">
                          <Card.Title
                            className="form-body-content-title"
                            style={{
                              display: "flex",
                              marginLeft: "10px",
                              flexWrap: "wrap",
                              padding: "0px",
                            }}
                          >
                            {form.formName}
                          </Card.Title>
                          <Card.Body
                            className="form-body-content-body"
                            style={{ padding: "0px", cursor: "pointer" }}
                            onClick={() =>
                              form.adminStatus === "Approved" ||
                              form.FormStatus === "Submitted"
                                ? handleRectangleClick(form.AdminLink)
                                : handleRectangleClick(form.url)
                            }
                          >
                            <div className="form-status">
                              <span>Status:</span>
                              <span>{form.FormStatus}</span>
                            </div>
                            <div className="updated-date">
                              {form.updatedAt ? (
                                <>
                                  <span>Updated:</span>
                                  <span>
                                    {new Date(
                                      form.updatedAt
                                    ).toLocaleDateString()}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <span>Date:</span>
                                  <span>
                                    {form.createdAt
                                      ? new Date(
                                          form.createdAt
                                        ).toLocaleDateString()
                                      : ""}
                                  </span>
                                </>
                              )}
                            </div>
                          </Card.Body>
                        </div>
                      </div>
                    </Card>
                  ))
                ) : (
                  <Card style={{ height: "300px", width: "100%" }}>
                    <Card.Body>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          paddingTop: "20%",
                        }}
                      >
                        <BsInbox
                          style={{
                            alignSelf: "center",
                            width: "50px",
                            height: "50px",
                          }}
                        />
                        <p style={{ alignSelf: "center" }}>
                          No assigned forms !.
                        </p>
                      </div>
                    </Card.Body>
                  </Card>
                )}
              </Col>
            </Card>
          </Card>
        </div>
      </div>
      <div className="appointments-cards">
        <Card className="appointment-main-card">
          <h5 className="upcoming-appointment-title">Upcoming Appointments</h5>
          <Card.Body>
            <div
              style={{
                border: "1px solid #ddd",
                borderRadius: "5px",
                overflow: "hidden",
                padding: "5px",
                backgroundColor: "#a0a0b33c",
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              {clientDetails?.appointments?.length > 0 ? (
                clientDetails.appointments
                  .slice(0, 5)
                  .sort(
                    (a, b) =>
                      new Date(a.appointmentDate).setHours(0, 0, 0, 0) -
                      new Date(b.appointmentDate).setHours(0, 0, 0, 0)
                  )
                  .map((data) => (
                    <Card
                      key={data.appointmentId}
                      style={{
                        backgroundColor: isTodaysAppointments.includes(data)
                          ? "#CEECF6"
                          : "#ffff",
                      }}
                      className="appointments"
                    >
                      <Card.Body>
                        <div className="body-text">
                          <div className="pills">
                            <img
                              className="pill-icon"
                              src={appointment}
                              style={{
                                height: "60px",
                                width: "60px",
                                borderRadius: "50%",
                              }}
                              alt="Appointment Icon"
                            />
                          </div>
                          <div className="appointment-info">
                            <div className="text-title">
                              {data.serviceTitle}
                            </div>
                            <div>Client: {data.userName}</div>
                            <div>Practitioner: {data.doctorName}</div>
                            <p>Date: {formatTime(data.appointmentDate)}</p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  ))
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignSelf: "center",
                    height: "410px",
                  }}
                >
                  <BsInbox
                    style={{
                      alignSelf: "center",
                      width: "50px",
                      height: "50px",
                    }}
                  />
                  <p style={{ alignSelf: "center" }}>No appointments !.</p>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default Profile;
